import { useToastContext } from "components/alert/ToastContext";
import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalDocumentoReprovar from "components/modal/documentos/ModalDocumentoReprovar";
import ModalRejeitarViagem from "components/modal/viagem/ModalRejeitarViagem";
import ModalViagemAprovacaoVisualizar from "components/modal/viagem/ModalViagemAprovacaoVisualizar";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import FinalizarAprovacao from "model/documentos/fluxo/FinalizarAprovacao";
import Viagem from "model/viagem/Viagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ViagemAprovacaoService from "service/viagem/ViagemAprovacaoService";
import { converterData } from "utils/convert";
import { filterApplyTemplate, IdListMatchModeOptions } from "utils/filterUtils";

const viagemAprovacaoService = new ViagemAprovacaoService();

export default function ViagemAprovacaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Aprovar viagens');
    const [centrosCusto, setCentrosCusto] = useState<CentroCusto[]>([]);
    const [centroCustoUsuario, setCentroCustoUsuario] = useState<number[]>([]);
    const [loading, setLoading] = useState(true);
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const listagemRef = useRef<BaseListagemRef>(null);
    const [modalVisualizarViagem, setModalVisualizarViagem] = useState<{ visible: boolean, idViagem: number }>({ visible: false, idViagem: 0 });
    const [modalRejeitarViagem, setModalRejeitarViagem] = useState<{ visible: boolean, viagem: Viagem|null }>({ visible: false, viagem: null });

    useEffect(() => {
        Promise.all([
            viagemAprovacaoService.getCentroCustoDisponiveis().then(setCentrosCusto).catch(err => console.error(err)),
            viagemAprovacaoService.getCentroCustoUsuario().then(setCentroCustoUsuario).catch(err => console.error(err))
        ]).finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        console.log(centroCustoUsuario)
    }, [centroCustoUsuario]);

    const defaultFilters = useMemo<DataTableFilterMeta>(() => ({
        codigo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoRotina: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        centroCusto: {
            constraints: [
                {
                    value: centroCustoUsuario,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }), [centroCustoUsuario]);

    const centroCustoFilterTemplate = (options: ColumnFilterElementTemplateOptions, opcoes: any[]) => {
        return <MultiSelect value={options.value} options={opcoes}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    if (loading) {
        return;
    }

    const aprovarViagem = (viagem: Viagem) => {
        startLoading();
        viagemAprovacaoService.aprovar(viagem.id).then((v) => {
            msgSucesso('Viagem', 'Viagem aprovada com sucesso');
            listagemRef.current?.reload();
        }).catch(e => {
            msgErro('Viagem', e.data.message);
        }).finally(() => {
            stopLoading()
        });
    };

    return (
        <>
            {modalVisualizarViagem.visible && <ModalViagemAprovacaoVisualizar
                visible={modalVisualizarViagem.visible}
                idViagem={modalVisualizarViagem.idViagem}
                onHide={() => setModalVisualizarViagem({ visible: false, idViagem: 0 })}
            />}
            {modalRejeitarViagem.visible && <ModalRejeitarViagem
                visible={modalRejeitarViagem.visible}
                viagem={modalRejeitarViagem.viagem}
                onHide={() => setModalRejeitarViagem({ visible: false, viagem: null })}
                onConfirm={() => {
                    listagemRef.current?.reload();
                    setModalRejeitarViagem({ visible: false, viagem: null })
                }}
            />}
            <BaseListagem ref={listagemRef} ordenacao="dataPartida,DESC" service={viagemAprovacaoService} urlService="/viagemaprovacao" defaultFilters={defaultFilters} showClearFilterButton tituloPagina={titulo} showNewButton={false} showEditButton={false} showRemoveButton={false}>
                <Column field="codigo" header="Nr." />
                <Column field="dataPartida" header="Data partida" showAddButton={false}
                    body={(rowData) => converterData(rowData.dataPartida)}
                />
                <Column
                    field="usuarioSolicitante.nome" header="Solicitante" showAddButton={false}
                />
                <Column
                    field="centroCusto.nome" header="Centro de Custo" showAddButton={false}
                    filter showFilterOperator={false} filterPlaceholder="Selecione" filterField="centroCusto"
                    filterMatchModeOptions={IdListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => centroCustoFilterTemplate(options, centrosCusto)}
                />
                <Column field="itinerario" header="Itinerário" />
                <Column field="valorAdiantamento" header="Adiantamento"
                    body={(rowData: Viagem) => rowData.valorAdiantamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                />
                <Column body={(rowData: Viagem) => {
                    return <Button icon="pi pi-eye" onClick={() => {
                        setModalVisualizarViagem({ visible: true, idViagem: rowData.id });
                    }} />
                }} />
                <Column style={{ width: 250 }} body={(rowData: Viagem) => {
                    return <>
                        <Button label="Aprovar" onClick={() => {
                            confirmDialog({
                                message: 'Deseja aprovar esta viagem?',
                                header: 'Aprovar viagem',
                                icon: 'pi pi-info-circle',
                                acceptLabel: 'Aprovar',
                                rejectLabel: 'Cancelar',
                                accept: () => {
                                    aprovarViagem(rowData);
                                },
                                reject: () => {

                                }
                            })
                        }} className="p-button-success" />
                        <Button label="Rejeitar" onClick={() => {
                            setModalRejeitarViagem({ visible: true, viagem: rowData });
                        }} className="p-button-danger" style={{ marginLeft: 8 }} />
                    </>
                }} />

            </BaseListagem>
        </>
    )
}
